export default "__VITE_ASSET__cc94687a__"